/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';

/**
 * any person/role contributing to a database (db owner, entry author/editor, etc).
 * Enthält den Datensatz, den E-Card-/Newsletter-Absender-Templates über
 * `{{user.…}}`-Platzhalter beim Empfänger einsetzen (firstName, lastName,
 * phone, company, …). Felder sind read-only; geliefert wird, was der Customer
 * in seinem Profil hinterlegt hat.
 * @export
 * @interface DatabaseUser
 */
export interface DatabaseUser {
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly username?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly title?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly phone?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseUser
     */
    readonly company?: string;
    /**
     * 
     * @type {Address}
     * @memberof DatabaseUser
     */
    address?: Address;
}

/**
 * Check if a given object implements the DatabaseUser interface.
 */
export function instanceOfDatabaseUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseUserFromJSON(json: any): DatabaseUser {
    return DatabaseUserFromJSONTyped(json, false);
}

export function DatabaseUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'salutation': !exists(json, 'salutation') ? undefined : json['salutation'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
    };
}

export function DatabaseUserToJSON(value?: DatabaseUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': AddressToJSON(value.address),
    };
}

